<template>
    <toolbar-option type="stacked" :message="message">
        <template slot="secondary">
            <dropdown
                v-if="filteredStates.length > 1"
                :value="state"
                :options="filteredStates"
                native
                @input="onStateInput"
            />
        </template>

        <template slot="primary">
            <div class="f-flex f-justify-between f-items-center f-mt-0.25 f-mb-1">
                <div class="f-w-3/10">
                    <dropdown
                        :value="side"
                        :options="sideOptions"
                        native
                        @input="onSideInput"
                    />
                </div>

                <div class="f-w-3/10">
                    <border-style />
                </div>

                <div class="f-w-3/10">
                    <!-- we only apply state-specific styles for border colors -->
                    <border-color :state="state" />
                </div>
            </div>

            <slider
                :value="sliderIndex"
                :values="themeObjectValues"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
// note that only border-widths are supported on a per-side basis:
// https://github.com/tailwindcss/discuss/issues/46#issuecomment-343185807

import baseOption from '@/options/mixins/base-option-slider';
import BorderColor from '@/options/components/border-color';
import BorderStyle from '@/options/components/border-style';

export default {
    name: 'border',
    components: { BorderColor, BorderStyle },
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Border',
            message: '* only the width can be changed on a per-side basis',
            tailwindDefinitionProp: 'borderWidth',
            state: '',
            stateOptions: [
                {
                    text: 'Default',
                    value: '',
                },
                {
                    text: 'On Hover',
                    value: 'hover',
                },
                {
                    text: 'Selected',
                    value: 'selected',
                    displayFor: ['a-link', 'a-text-single-line', 'nav-dropdown', 'tab-container'],
                },
                {
                    text: 'Matching',
                    value: 'matching',
                    displayFor: ['a-link', 'nav-dropdown'],
                },
            ],
        };
    },

    computed: {
        filteredStates() {
            const { elementType } = this.selectedElements[0];

            return this.stateOptions.filter((state) => {
                if (state.displayFor) {
                    return state.displayFor.includes(elementType);
                }

                return true;
            });
        },
    },
};
</script>
